(function () {
  function initProductZoom() {
    const productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    // Get all images inside product media gallery
    const images = productSection.querySelectorAll('.product__media img');
    if (!images.length) return;

    images.forEach((img) => {
      // Prevent duplicate initialization
      if (img.dataset.zoomInitialized) return;
      img.dataset.zoomInitialized = "true";

      const glass = document.createElement("div");
      glass.className = "spark-zoom-glass";
      document.body.appendChild(glass);

      const zoomPower = 3;
      const glassSize = 250;
      const half = glassSize / 2;

      Object.assign(glass.style, {
        position: "absolute",
        width: glassSize + "px",
        height: glassSize + "px",
        borderRadius: "50%",
        pointerEvents: "none",
        display: "none",
        backgroundRepeat: "no-repeat",
        zIndex: "9999",
        boxShadow: "0 0 10px rgba(0,0,0,0.2)"
      });

      function move(e) {
        const rect = img.getBoundingClientRect();
        const x = e.pageX;
        const y = e.pageY;

        const left = rect.left + window.scrollX;
        const top = rect.top + window.scrollY;

        if (
          x > left &&
          x < left + rect.width &&
          y > top &&
          y < top + rect.height
        ) {
          const percentX = ((x - left) / rect.width) * 100;
          const percentY = ((y - top) / rect.height) * 100;

          glass.style.left = x - half + "px";
          glass.style.top = y - half + "px";
          glass.style.backgroundImage = `url('${img.src}')`;
          glass.style.backgroundSize =
            rect.width * zoomPower + "px " + rect.height * zoomPower + "px";
          glass.style.backgroundPosition = percentX + "% " + percentY + "%";
          glass.style.display = "block";
        } else {
          glass.style.display = "none";
        }
      }

      img.addEventListener("mousemove", move);
      img.addEventListener("mouseleave", () => {
        glass.style.display = "none";
      });
    });

    // Reinitialize on variant image change
    document.addEventListener("variant:change", function () {
      images.forEach((img) => (img.dataset.zoomInitialized = ""));
      document.querySelectorAll('.spark-zoom-glass').forEach((g) => g.remove());
      initProductZoom();
    });
  }

  document.addEventListener("DOMContentLoaded", initProductZoom);
})();